import {
  type SmartIdPrepareSignatureMutationVariables,
  useSmartIdPrepareSignatureMutation,
} from 'api/core/generated';
import { AppApiVersions } from 'app-constants';

export const useSignContractWithSmartId = () => {
  const [prepareForSmartIdSigning, { data, loading, error }] =
    useSmartIdPrepareSignatureMutation({
      context: { apiVersion: AppApiVersions.core },
    });

  const prepareSmartIdContractSignature = (
    variables: SmartIdPrepareSignatureMutationVariables,
  ) => prepareForSmartIdSigning({ variables });

  return {
    smartIdContractSignaturePreparationLoading: loading,
    smartIdContractSignaturePreparationChallenge: data?.challenge ?? null,
    smartIdContractSignaturePreparationError: error,
    prepareSmartIdContractSignature,
  };
};
